import React from 'react';

import { WithNiatApplicationPortalMachineProps } from '../hocs/withNiatApplicationPortalMachine';

interface NiatApplicationMachineProviderProps {
  children: React.ReactNode;
  value: WithNiatApplicationPortalMachineProps;
}

const NiatApplicationMachineContext = React.createContext<
  WithNiatApplicationPortalMachineProps | undefined
>(undefined);

export const NiatApplicationMachineProvider: React.FC<
  NiatApplicationMachineProviderProps
> = ({ children, value }) => {
  return (
    <NiatApplicationMachineContext.Provider value={value}>
      {children}
    </NiatApplicationMachineContext.Provider>
  );
};

export const useNiatApplicationMachineContext =
  (): WithNiatApplicationPortalMachineProps => {
    const context = React.useContext(NiatApplicationMachineContext);
    if (context === undefined) {
      throw new Error(
        'useNiatApplicationMachineContext must be used within a NiatApplicationMachineProvider'
      );
    }
    return context;
  };
